module.exports = __webpack_public_path__ + "img/candi-nav-3.50e00f81.svg";